// 判断是否为数组
export function isArray(o){
  return Object.prototype.toString.call(o)=='[object Array]';
}

// 判断是否为数字
export function isNumber(o){
  return typeof o === 'number'
}
